import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=5cddfdaf&scoped=true&"
import script from "./DeleteModal.vue?vue&type=script&lang=js&"
export * from "./DeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cddfdaf",
  null
  
)

export default component.exports